/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".slider[_ngcontent-%COMP%]{width:75%;margin:50px auto}.valor-simular[_ngcontent-%COMP%]{font-size:3rem;font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;color:#717171}.slider-warning[_ngcontent-%COMP%]{color:#ff720a;font-weight:600;font-size:18px}.disabled-event[_ngcontent-%COMP%]{pointer-events:none}"];
export { styles as styles };
